export class SubCities {
  static cityNames: string[] = Array.from(new Set(["Al Aqiq","Al Ghadir","Al Hamra","Al Izdihar","Al Malaz","Al Malqa","Al Olaya","Al Qirawan","Al Quds","Al Wadi","Al Wurud","Almasiaf","Alyasmin","An Nada","An Nakheel","An Narjis","An Nuzhah","Ar Rabi","Ar Rahmaniyyah","Ar Rimal","As Sahafah","As Sulimaniyah","At Taawun","King Khalid International Airport","King Salman Neighborhood","Qurtubah","Riyadh"]));

}
